import React from 'react';
import classNames from 'classnames';

import { JourneyMenuPropsInterface } from 'src/common/JourneyMenu';

import LoadingSpinner from 'src/common/components/loading-spinner';
import { FrameImageLightIcon } from 'src/monet/icons';
import { useShareThumbnailCodeStore } from '../../../thumbnail-code/store';
import { CopyToClipboardWithStyles } from 'src/dashboard/JourneyShareThumbnailCode';
import { thumbnailElementId } from '../../../thumbnail-code/get-template';
import { useNotificationMessage } from 'src/common/notification/message.hook';
import { SmallPanel } from 'src/common/ui/small-panel';

interface Props
  extends Pick<JourneyMenuPropsInterface, 'openRef' | 'closeRef' | 'placement' | 'offset' | 'renderOrigin'> {
  onCopy?: () => void;
  onBack?: () => void;
  onOpen?: () => void;
  onClose?: () => void;
  hasBackButton?: boolean;
  containerClassName?: string;
  originClassName?: string;
  openAfterMount?: boolean;
}

const LinkShareThumbnailPanel = ({
  renderOrigin,
  openRef,
  closeRef,
  offset,
  placement,
  onCopy,
  onBack,
  onOpen,
  onClose,
  hasBackButton = true,
  openAfterMount = true,
  containerClassName,
  originClassName,
}: Props) => {
  const isThumbnailReady = useShareThumbnailCodeStore((state) => !!state.thumbnailElement);

  const { setSuccessNotification } = useNotificationMessage();

  const onCopyLinkMenuItemClicked = () => {
    CopyToClipboardWithStyles(thumbnailElementId);
    setSuccessNotification('Thumbnail link copied to clipboard');
    onCopy?.();
  };

  return (
    <SmallPanel
      placement={placement}
      offset={offset}
      containerClassName={containerClassName}
      originClassName={originClassName}
      openAfterMount={openAfterMount}
      fixed
      hasBackButton={hasBackButton}
      openRef={openRef}
      closeRef={closeRef}
      onBack={onBack}
      onOpen={onOpen}
      onClose={onClose}
      renderOrigin={renderOrigin}
    >
      {!isThumbnailReady ? (
        <div className='flex items-center justify-center h-[66px]'>
          <LoadingSpinner />
        </div>
      ) : (
        <>
          <div className='text-bedrock-p-small text-left text-bedrock-black pointer-events-none'>
            Use this link within Gmail to show a thumbnail of your Journey
          </div>
          <div
            className={classNames('text-bedrock-p text-bedrock-black flex items-start space-x-sm text-left', {
              'pointer-events-none': !isThumbnailReady,
              'cursor-pointer': isThumbnailReady,
            })}
            onClick={onCopyLinkMenuItemClicked}
          >
            <div className='flex space-x-2'>
              <FrameImageLightIcon className='shrink-0' />
              <span className='text-bedrock-p'>Copy thumbnail link</span>
            </div>
          </div>
        </>
      )}
    </SmallPanel>
  );
};

export default LinkShareThumbnailPanel;
